<template>
  <div>
    <form class="inquiries-form" @submit.prevent="onSubmitForm">
      <div>
        <div class="mb-1">
          {{ $i18nPresenter.t('Your name') }}
        </div>
        <aha-input
          type="text"
          required
          v-model="formData.inquirerName"
        />
      </div>
      <div class="-mb-5">
        <div class="mb-1">
          {{ $i18nPresenter.t('Work email') }}
        </div>
        <aha-input
          type="email"
          required
          v-model="formData.workEmail"
          :placeholder="$i18nPresenter.t('name@yourcompany.com')"
        />
        <div v-if="!isValidWorkEmail" class="text-xs text-pink-100">
          {{ $i18nPresenter.t('Please enter a valid work email address') }}
        </div>
      </div>
      <div>
        <div class="mb-1">
          {{ $i18nPresenter.t('Phone number (optional)') }}
        </div>
        <aha-input
          type="tel"
          v-model="formData.phoneNumber"
          :placeholder="$i18nPresenter.t('+0 (123) 456-789')"
        />
      </div>
      <div>
        <div class="mb-1">
          {{ $i18nPresenter.t('Job title (optional)') }}
        </div>
        <aha-input
          type="text"
          v-model="formData.jobTitle"
        />
      </div>
      <div class="full-w">
        <div class="mb-1">
          {{ $i18nPresenter.t('Message (optional)') }}
        </div>
        <aha-textarea
          v-model="formData.message"
          class="text-area"
          :placeholder="$i18nPresenter.t('How can our Enterprise team help you?')"
          :max-length="500"
        />
      </div>
      <div class="full-w">
        <aha-checkbox
          v-model="formData.receiveUpdatedEmail"
        >
          <span>{{ $i18nPresenter.t("Receive AhaSlides updates and offers") }}</span>
        </aha-checkbox>
      </div>
      <div class="inline-flex justify-between full-w">
        <aha-antd-button
          variant="link"
          class="--learn-more-btn"
          @click="toEnterprisePage"
        >
          <span class="flex items-center gap-1">
            {{ $i18nPresenter.t('Learn more') }}
            <aha-icon
              class="icon"
              name="open-new-window"
              viewBox="0 0 24 24"
              width="16"
              height="16"
            />
          </span>
        </aha-antd-button>
        <aha-antd-button
          name="submit-enterprise-inquiry"
          v-aha-emit-action
          tabindex="0"
          type="submit"
          is-loading-inline
          class="submit-request"
          :disabled="!isValidForm"
          :submitting="submitting"
        >
          <span class="pl-4 pr-4">{{ $i18nPresenter.t('Submit') }}</span>
        </aha-antd-button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import PersonalEmailValidationMixin from '../common/PersonalEmailValidationMixin'

export default {
  name: 'EnterpriseInquiriesForm',
  mixins: [PersonalEmailValidationMixin],
  props: {
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitting: false,
      options: [
        {
          value: '1-10',
          label: '1-10',
        },
        {
          value: '11-50',
          label: '11-50',
        },
        {
          value: '51-100',
          label: '51-100',
        },
        {
          value: '101-250',
          label: '101-250',
        },
        {
          value: '250-1000',
          label: '250-1000',
        },
        {
          value: '1000+',
          label: '1000+',
        },
      ],
      formData: {
        inquirerName: '',
        workEmail: this.email,
        phoneNumber: '',
        jobTitle: '',
        message: '',
        receiveUpdatedEmail: false,
      },
    }
  },
  computed: {
    presenterPerAccountTooltip() {
      return this.$i18nPresenter.t('Total people in your team who will use AhaSlides to host events.')
    },
    isValidForm() {
      return this.isValidWorkEmail
    },
  },
  methods: {
    ...mapActions(['submitEnterpriseInquiriesFormAction']),
    toEnterprisePage() {
      // open new window
      window.open('https://ahaslides.com/enterprise/', '_blank')
    },
    mapFormData(payload) {
      const {
        inquirerName, workEmail, phoneNumber,
        jobTitle, message, receiveUpdatedEmail,
      } = payload
      return {
        inquirerName,
        workEmail,
        phoneNumber,
        jobTitle,
        message,
        receiveUpdatedEmail,
      }
    },
    async onSubmitForm() {
      this.submitting = true
      const submitData = this.mapFormData(this.formData)
      await this.submitEnterpriseInquiriesFormAction(submitData)
      // for iframe
      if (window.parent) {
        window.parent.postMessage({
          action: 'submitted-enterprise-inquiries-form',
        }, '*')
      }
      this.$emit('submittedForm')
    },
  },
}
</script>
<style scoped lang="scss">
.inquiries-form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;

    & .full-w {
        grid-column: span 2;
    }

    @media (max-width: 600px) {
        & > * {
            grid-column: span 2;
        }
    }

    &::v-deep .aha-textarea {
      margin-top: 0;
      margin-bottom: 0;
    }

    .--learn-more-btn {
      padding-left: 0;
    }
}
</style>
